export const BulkCreationConfirmTabCloseMixin = {
  data () {
    return {
      isShowCreationForm: false
    }
  },
  watch: {
    isShowCreationForm: function (val) {
      if (val) {
        window.addEventListener('beforeunload', this.handleBeforeUnload)
      } else {
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  methods: {
    handleBeforeUnload (event) {
      event.preventDefault() // Recommended for best compatibility

      // Included for legacy support, e.g. Chrome/Edge < 119
      event.returnValue = true
    }
  }
}
